// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rDph","signatureBlock":"Footer_signatureBlock__3XY9D","signature":"Footer_signature__3tvhZ"};